<template>
  <Headers> </Headers>
  <!-- {{ prop.ekyc.refId }} -->
  <div :class="[deviceType, 'progressContainer']">
    <PogressBarStep :cardName="prop.cardName" :currentStep="2">
    </PogressBarStep>
    <div :class="[deviceType, 'inner']">
      <div :class="[deviceType, 'container-sm']">
        <div class="subcontainer" v-if="deviceType != 'Mobile'">
          <div class="qr-container col-sm-4 col-12">
            <div class="img-container">
              <div v-if="!prop.ekyc.url">
                <div v-if="prop.ekyc.fail">
                  <img
                    class="path-65 retry_logo"
                    src="../../../assets/icons/bio_timeout.svg"
                  />
                </div>
                <div v-else class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>

              <div v-else>
                <QRCodeVue
                  v-if="isURLValid(prop.ekyc.url)"
                  :value="prop.ekyc.url"
                  :size="170"
                  level="L"
                  renderAs="svg"
                  @error="handleImageError"
                />
              </div>
            </div>
            <p
              v-if="currentTime3 >= 1 && isURLValid(prop.ekyc.url)"
              class="resendText"
            >
              {{ formattedTime }}
            </p>
            <p
              v-else-if="currentTime3 == 0 && isURLValid(prop.ekyc.url)"
              class="resendText"
            >
              {{ t("ccOnBoarding.timeout") }}
            </p>

            <!-- <div class="qr-bottom-footer">
              <p
                class="resendText"
                v-if="countdown !== 60 && countdown != 0 && countdown > 9"
              >
                {{ t("ccOnBoarding.ekyc.resend1") }}{{ countdown }}
              </p>
              <p
                class="resendText"
                v-if="countdown !== 60 && countdown != 0 && countdown <= 9"
              >
                {{ t("ccOnBoarding.ekyc.resend2") }}{{ countdown }}
              </p>
            </div> -->
          </div>
          <div class="text-container">
            <div class="text-subcontainer">
              <div class="scan-qr-for-e-kyc">
                {{ t("ccOnBoarding.ekyc.scan") }}
              </div>
              <div
                class="open-qr-scanner-on-your-mobile-device-scan-the-qr-code-displayed-follow-and-complete-the-e-kyc-process"
              >
                {{ t("ccOnBoarding.ekyc.remark") }} <br />
                {{ t("ccOnBoarding.ekyc.remark1") }} <br />
                {{ t("ccOnBoarding.ekyc.remark2") }} <br />
                {{ t("ccOnBoarding.ekyc.remark3") }} <br />
              </div>
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-if="prop.ekyc.fail"
              >
 {{ t("ccOnBoarding.ekyc.ekycTimeOut") }} </pre
              >
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-else-if="prop.ekyc.status == 'FAILED'"
              >
 {{ t("ccOnBoarding.ekyc.ekycFail") }} </pre
              >
              <pre class="helpNull" v-else></pre>
              <div class="buttoncontainer">
                <button
                  v-if="
                    prop.ekycGetFailed ||
                    currentTime3 == 0 ||
                    proceed ||
                    prop.ekyc.status == 'FAILED' ||
                    prop.ekyc.fail
                  "
                  class="left-button"
                  type="button"
                  @click="skip"
                >
                  {{ t("ccOnBoarding.ekyc.button1") }}
                </button>
                <button
                  v-else-if="
                    !prop.ekycGetFailed ||
                    currentTime3 != 0 ||
                    !proceed ||
                    prop.ekyc.status != 'FAILED'
                  "
                  class="left-button_noBorder"
                ></button>
                <button
                  class="right-button"
                  @click="handleClick"
                  :disabled="prop.ekyc.refreshBtnDisabled || isDisabled"
                >
                  {{ t("ccOnBoarding.ekyc.button2") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="deviceType != 'Mobile'"
          :class="[deviceType, 'back-buttoncontainer']"
        >
          <button
            :class="[deviceType, 'back-left-button']"
            :disabled="prop.ekyc.backBtnDisabled"
            type="button"
            @click="back"
          >
            {{ t("ccOnBoarding.back") }}
          </button>
        </div>
      </div>

      <div v-if="deviceType == 'Mobile'" class="errorMsg">
        <!-- <a
          target="_blank"
          href="https://101.78.26.53/gateway/#/guideline?token=5078fe1d43a58b582f3c3ade7a6b3f80EKYC20240404142316000825"
          >Bypass link</a
        > -->
        <pre
          class="help"
          style="
            white-space: pre-wrap;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
          "
          v-if="prop.ekyc.fail"
        >
 {{ t("ccOnBoarding.ekyc.ekycTimeOutMobile") }} </pre
        >
        <pre
          class="help"
          style="
            white-space: pre-wrap;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
          "
          v-else-if="prop.ekyc.status == 'FAILED'"
        >
 {{ t("ccOnBoarding.ekyc.ekycFailMobile") }} </pre
        >
        <pre class="helpNull" v-else></pre>
      </div>

      <div v-if="deviceType == 'Mobile'" class="mobile-buttoncontainer">
        <button
          v-if="
            prop.ekycGetFailed ||
            currentTime3 == 0 ||
            proceed ||
            prop.ekyc.status == 'FAILED' ||
            prop.ekyc.fail
          "
          class="mobile-left-button"
          type="button"
          @click="skip"
        >
          {{ t("ccOnBoarding.ekyc.button1") }}
        </button>
        <button
          v-if="prop.ekyc.status == 'FAILED' || prop.ekyc.fail"
          class="mobile-right-button"
          :disabled="prop.ekyc.refreshBtnDisabled || isDisabled"
          @click="handleClick"
        >
          {{ t("ccOnBoarding.ekyc.button3") }}
        </button>
        <button v-else class="left-button_noBorder"></button>
      </div>
      <div class="subcontainer_Mobile" v-if="deviceType == 'Mobile'">
        <div v-if="!prop.ekyc.url">
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div v-else>
          <iframe
            class="iframe"
            :src="prop.ekyc.url"
            allow="camera; microphone; autoplay"
            width="100%"
            height="700"
            frameborder="0"
          ></iframe>
        </div>
      </div>
      <div
        v-if="deviceType == 'Mobile'"
        :class="[deviceType, 'back-buttoncontainer']"
      >
        <button
          :class="[deviceType, 'back-left-button']"
          type="button"
          :disabled="prop.ekyc.backBtnDisabled"
          @click="back"
        >
          {{ t("ccOnBoarding.back") }}
        </button>
      </div>
    </div>
  </div>
  <div v-if="prop.overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  computed,
  type PropType,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  watch,
} from "vue";
import Headers from "./components/Headers.vue";
import PogressBarStep from "./components/ProgressBarStep.vue";
import i18n from "@/plugin/i18n";
import QRCodeVue from "qrcode.vue";
import { type Ekyc } from "@/interface/FormCC";
import { deviceDetect } from "mobile-device-detect";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

const { t } = i18n.global;
const deviceType = ref("");
const totalTimeInSeconds = 10 * 60;
const currentTime3 = ref(totalTimeInSeconds);
const outOfTime = ref(false);
const isCountdownActive = ref(true);
const proceed = ref(false);
const imageError = ref(false);
const timeOut = ref(false);
const isDisabled = ref(false);
const initialTime = ref(totalTimeInSeconds);
const startTime3 = ref(Date.now());
let timerId: number;

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

const handleImageError = () => {
  imageError.value = true;
};

const emit = defineEmits([
  "nextStep",
  "previousStep",
  "jumpStep",
  "ekycGenerate",
  "listenerEkyc",
  "updateFlag",
  "submit",
  "updateOTPFlag",
  "tokenSessionTimeOut",
]);

const prop = defineProps({
  ekyc: {
    type: Object as PropType<Ekyc>,
    required: true,
  },
  ekycGetFailed: {
    type: Boolean,
    required: true,
  },
  cardName: {
    type: String,
    required: true,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  otpVerified: {
    type: String,
    required: true,
  },
  preStatus: {
    type: String,
  },
  failedStatus: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
  },
  token: {
    type: String,
    required: true,
  },
});

const isURLValid = (url: string): boolean => {
  if (!url) {
    return false;
  }
  const pattern = /^((http|https):\/\/)?[^\s$.?#].[^\s]*$/;
  return pattern.test(url);
};

const qrCode = ref(prop.ekyc.url);
onBeforeMount(() => {
  if (!prop.failedStatus) {
    emit("ekycGenerate");
  }
});

const isFirstRefIdSet = ref(false);

watch(
  () => prop.ekyc.refId,
  (newValue) => {
    if (!isFirstRefIdSet.value && newValue && isURLValid(prop.ekyc.url)) {
      emit("listenerEkyc");
      isFirstRefIdSet.value = true;
    }
  }
);

watch(
  () => prop.ekyc.status,
  (newValue) => {
    if (newValue == "COMPLETE") {
      if (prop.otpVerified == "true") {
        if (prop.preStatus != "") {
          emit("updateOTPFlag");
          emit("jumpStep", 4, "", 2);
        } else {
          emit("submit");
        }
      } else {
        emit("jumpStep", 3, "", 2);
      }
    }
  }
);

watch(
  () => currentTime3.value,
  (newValue) => {
    if (newValue == 0) {
      proceed.value = true;
    }
  }
);

const skip = () => {
  const requestModel = {
    webFormRequestId: prop.ekyc.webFormRequestId,
  };
  MasterService.removeEKYC(requestModel, prop.token)
    .then((res) => {
      if (res.status == 200) {
        prop.ekyc.status = "SKIP";
        if (prop.otpVerified == "true") {
          emit("updateOTPFlag");
          emit("jumpStep", 4, "", 2);
        } else {
          emit("jumpStep", 3, "", 2);
        }
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        emit("tokenSessionTimeOut");
      }
    });
};

const refresh = () => {
  isCountdownActive.value = true;
  // totalTimeInSeconds.value = 15;
  prop.ekyc.url = "";
  if (prop.ekyc.status == "FAILED" || prop.ekyc.fail) {
    proceed.value = true;
  }
  prop.ekyc.status = "";
  prop.ekyc.fail = false;
  isFirstRefIdSet.value = false;
};

const handleClick = () => {
  if (!prop.ekyc.refreshBtnDisabled) {
    isDisabled.value = true;
    prop.ekyc.refreshBtnDisabled = true;
    const requestModel = {
      webFormRequestId: prop.ekyc.webFormRequestId,
    };
    MasterService.removeEKYC(requestModel, prop.token)
      .then((res) => {
        if (res.status == 200) {
          refresh();
          emit("ekycGenerate");
          // Re-enable the button after the operation is complete
          setTimeout(() => {
            isDisabled.value = false;
          }, 3000); // Adjust the timeout as needed
          currentTime3.value = totalTimeInSeconds;
          initialTime.value = totalTimeInSeconds;
          startTime3.value = Date.now();
        }
      })
      .catch((e) => {
        if (e.response && e.response.data.code == "WB-401") {
          // EndSession
          emit("tokenSessionTimeOut");
        } else {
          prop.ekyc.fail = true;
          prop.ekyc.refreshBtnDisabled = false;
          prop.ekyc.backBtnDisabled = false;
          isDisabled.value = false;
        }
      });
  }
};

// const updateTimer = () => {
//   if (isCountdownActive.value && currentTime.value > 0) {
//     currentTime.value--;
//   } else if (currentTime.value === 0) {
//     isCountdownActive.value = false;
//   }
// };

const updateTimerEKYC = () => {
  const elapsedTime = Math.floor((Date.now() - startTime3.value) / 1000);
  const newTime = initialTime.value - elapsedTime;

  if (newTime > 0 && isCountdownActive.value) {
    currentTime3.value = newTime;
    timerId = requestAnimationFrame(updateTimerEKYC); // Request the next frame
  } else {
    currentTime3.value = 0;
    isCountdownActive.value = false;
    cancelAnimationFrame(timerId); // Stop the loop
  }
};

const formattedTime = computed(() => {
  if (isCountdownActive.value) {
    const minutes = Math.floor(currentTime3.value / 60);
    const seconds = currentTime3.value % 60;
    // Format minutes and seconds as two-digit strings
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    return `${formattedMinutes} : ${formattedSeconds}`;
  }
});

onMounted(() => {
  // if (deviceType.value != "Mobile") {
  if (isCountdownActive) {
    // const timerInterval = setInterval(updateTimer, 1000);
    if (isCountdownActive.value) {
      startTime3.value = Date.now(); // Record the start time
      updateTimerEKYC(); // Start the countdown loop
      formattedTime;
    }
    // onBeforeUnmount(() => {
    //   clearInterval(timerInterval);
    // });
  }
  // }
});

watch(
  () => currentTime3.value,
  (newValue) => {
    if (newValue == 0) {
      outOfTime.value = true;
    }
  }
);

const back = () => {
  if (prop.ekyc.status == "" || prop.ekyc.status == "PENDING") {
    emit("updateFlag");
  }
  isCountdownActive.value = false;
  if (prop.type == "BIO") {
    emit("jumpStep", 0, "", 2);
  } else emit("jumpStep", 1, "", 2);
};
</script>

<style scoped>
.progressContainer {
  padding: 4% 8%;
  background: #fff;
  margin: auto;
  max-width: 1440px;
}

.container-sm {
  padding: 4% 8%;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  margin-top: 24px;
  max-width: 1440px;
  margin: auto;
}
.subcontainer {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.08);
}

.subcontainer_Mobile {
  border-radius: 16px;
  flex-direction: row;
  gap: 32px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  box-shadow: none;
  margin: 15px 0;
}
.qr-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}
.img-container {
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}
.image-9 {
  flex-shrink: 0;
  width: 250px;
  height: 250px;
  position: relative;
}
.qr-bottom-footer {
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-end;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.already-have-an-acco {
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  text-align: center;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
}
.qr-text-button-default {
  color: var(--black-low-38, rgba(0, 0, 0, 0.38));
  text-align: left;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
}
.text-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
  position: relative;
}
.text-subcontainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.scan-qr-for-e-kyc {
  color: var(--black-high-87, rgba(0, 0, 0, 0.87));
  text-align: left;
  font: var(--h-1, 500 22px/130% "Outfit", sans-serif);
  position: relative;
  align-self: stretch;
}
.open-qr-scanner-on-your-mobile-device-scan-the-qr-code-displayed-follow-and-complete-the-e-kyc-process {
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  text-align: left;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
  align-self: stretch;
}

.resendText {
  color: var(--black-low-38, rgba(0, 0, 0, 0.38));
  text-align: center;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
  margin-bottom: 0;
}

.text-button-small {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}

.text-button-default {
  color: var(--primary-active, #ac2887);
  text-align: left;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
  margin-bottom: 0;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  gap: 5px;
  width: 100%;
}

.back-buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 24px;
}

.mobile-buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  gap: 5px;
  width: 100%;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 10px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-right-button {
  width: 50%;
  height: 40px;
  padding: 8px 10px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.right-button:disabled,
.mobile-right-button:disabled {
  background: #dedede;
  color: #fff;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 10px;
  border-radius: 24px;
  border: 1px solid #ac2887;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #ac2887;
  flex: 0 0 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.back-left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;
  flex: 0 0 25%;
}

.back-left-button:disabled {
  background: #dedede;
  color: #fff;
  border: none;
}

.mobile-left-button {
  width: 50%;
  height: 40px;
  padding: 8px 10px;
  border-radius: 24px;
  border: 1px solid #ac2887;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #ac2887;
  flex: 0 0 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.left-button_noBorder {
  width: 100%;
  height: 40px;
  padding: 8px 10px;
  border-radius: 24px;
  border: none;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #ac2887;
  flex: 0 0 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: black;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

.help {
  color: red;
  font: 400 14px/130% "Outfit", sans-serif;
  margin-bottom: 0;
}

.helpNull {
  margin-bottom: 18px;
}

.errorMsg {
  margin-bottom: 10px;
}

@media (max-width: 500px) {
  .image-9:is(.Desktop, .Tablet) {
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 991px) {
  .qr-text-button-default:is(.Desktop, .Tablet) {
    text-align: center;
  }

  .container-sm:is(.Desktop, .Tablet) {
    padding: 0 20px;
    margin-top: 24px;
  }
}

@media (max-width: 991px) and (min-width: 575px) {
  .qr-bottom-footer:is(.Desktop, .Tablet) {
    display: block;
  }
}

@media (max-width: 576px) {
  .container-sm:is(.Desktop, .Tablet) {
    padding: 0 50px;
  }
  .back-left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }
}

@media (max-width: 420px) {
  .open-qr-scanner-on-your-mobile-device-scan-the-qr-code-displayed-follow-and-complete-the-e-kyc-process:is(
      .Desktop,
      .Tablet
    ) {
    font: var(--subtitle-2, 500 12px/130% "Outfit", sans-serif);
  }
  .back-left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }
}

/* Mobile */
.container-sm:is(.Mobile) {
  padding: 0;
  margin-top: 24px;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner:is(.Mobile) {
  padding: 0 20px;
}

.subcontainer_Mobile::-webkit-scrollbar-thumb {
  background: red;
}

.iframe::-webkit-scrollbar-thumb {
  background: red;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.back-left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.retry_logo {
  width: 80px;
  height: 80px;
  display: flex;
  margin: auto;
}
</style>
